import { Tooltip } from 'antd'
import _ from 'lodash'
import React from 'react'
import { LineChart, Line, CartesianGrid, ResponsiveContainer, XAxis, YAxis, BarChart, Bar, Rectangle, Legend, Text } from 'recharts'
import { handleNestedObjectKey } from 'utils'
import { isMobile } from 'react-device-detect'

import { applyColor } from 'utils/apply-color'

const TechBaseChartContent = props => {
  let {
    lines,
    width,
    height,
    minHeight,
    data,
    config,
    variant,
    dataKey,
    bars,
    yAxisWidth
  } = props.item

  const tickFormater = ({ x, y, payload }) => {


    const width = isMobile ? 55 : 100;
    if (payload && payload.value) {
      return (
        <Text
          width={width}  // Use the dynamic width
          x={x}
          y={y}
          textAnchor='middle'
          verticalAnchor='start'
          style={{ display: 'flex', flexDirection: 'column' }}
          dy={5}
        >
          {payload.value}
        </Text>
      )
    }
  }

  const CustomizedAxisTick = ({ x, y, payload }) => {
    return (
      <g transform={`translate(${x},${y})`} width={'100%'}>
        <text x={0} y={0} dy={2} textAnchor="end" fill="#666" transform="rotate(-90)">{payload.value}</text>
      </g>
    );
  }

  return (
    <ResponsiveContainer width={width} height={height} minWidth={300} minHeight={minHeight || 300}>
      {
        variant === 'line' && (<LineChart data={data}>
          {
            lines?.map(line => (
              <Line {...applyColor(line, props.colors)} />
            ))
          }
          <CartesianGrid {...config.CartesianGrid} />
          <XAxis {...config.xAxis} />
          <YAxis {...config.yAxis} />
        </LineChart>)
      }
      {
        variant === 'bar' && (<BarChart
          data={dataKey && handleNestedObjectKey(props, dataKey)}

        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis {...config.xAxis} tick={isMobile && config.isVerticle ? <CustomizedAxisTick /> : tickFormater} />
          <YAxis {...config.yAxis} width={yAxisWidth && handleNestedObjectKey(props, yAxisWidth)} />
          <Tooltip />
          <Legend
            wrapperStyle={{
              paddingTop: 30,
              fontWeight: 'bold',
            }}
          />
          {
            bars && _.map(bars, (bar) => (
              <Bar
                dataKey={bar.dataKeyName}
                fill={bar.fill}
                activeBar={<Rectangle fill={bar.highlighFill} stroke={bar.fill} />}
              />
            ))
          }
        </BarChart>)
      }
    </ResponsiveContainer>
  )
}

export default TechBaseChartContent